/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCq0F29FnaTUkU4_vVTdMzSSP61N5yxuqg",
    authDomain: "batterypoolapp.firebaseapp.com",
    databaseURL: "https://batterypoolapp.firebaseio.com",
    projectId: "batterypoolapp",
    storageBucket: "batterypoolapp.appspot.com",
    messagingSenderId: "299872120294",
    appId: "1:299872120294:web:21a9855ab61765e24efa27"
  },
  // Note: Add collections in env alphabetically.
  env:{
    "AssetsDashboardCollection": "AssetsDashboard",
    "BatteriesCollection":"Batteries",
    "BatteriesTypeCollection": "BatteriesType",
    "ChargersCollection": "Chargers",
    "ChargePointCollection": "ChargePointList",
    "CustomersCollection": "Customers",
    "DevicesCollection": "Devices",
    "EnvBaseUrl": "Batterypool",
    "EssUps":"EssUps",
    "EssBattery":"EssBattery",
    "GeofenceCollection": "Geofence",
    "IssuesFromWebCollection": "IssuesFromWeb",
    "LoginUsersCollection": "LoginUsers",
    "MobileNotificationsCollection": "MobileNotifications",
    "NotificationsCollection": "WebNotifications",
    "RentalCollection": "Rentals",
    "RidersCollection": "Riders",
    "RidersPaymentDashboardCollection": "RidersPaymentsDashboard",
    "RulesCollection" : "Rules",
    "ScootersCollection": "Scooters",
    "ServicemenCollection": "Servicemen",
    "SparePartsCollection":"SpareParts",
    "SwapStationInfoMap": "SwapStationInfoMap",
    "SwapStationCollection": "SwapStationList",
    "SwapTransactionsCollection": "SwapTransactions",
    "TotalEarningsDashboardCollection": "TotalEarningsDashboard",
    "TraccarDevicesCollection": "TracCarDevices",
    "TraccarDevicesPositionCollection": "TracCarDevicesPositions",
    "EvTripCollection": "EvTrip",
    "WorkordersCollection": "Workorders",
  }
};
